import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StudyListResolverService } from './services/study-list-resolver.service';
import { FirstNavigationGuard } from './services/first-navigation.guard';
import { ConfirmationService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { routes } from './app/app-routing.module';
import { importProvidersFrom } from '@angular/core';
import { appConfig } from './app/app.config';


bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,   // ✅ this applies PrimeNG theme

    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(FormsModule),
    importProvidersFrom(ReactiveFormsModule),

    ConfirmationService,
    StudyListResolverService,
    FirstNavigationGuard,
  ]
});